import meta from "./meta.json";
import profile from "./profile.json";
import settings from "./settings.json";
import general from "./general.json";

export default {
    meta,
    profile,
    settings,
    general,
};
